<!--
 * @Author: zxf
 * @Date: 2022-08-03 18:10:27
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 16:28:23
 * @Description: 消防设备登记
-->
<template>
  <div
    v-loading="loading"
    class="l-page--inner l-page--search"
  >
    <!-- 查询条件 Start -->
    <div
      class="l-page__item u-mg-b-10"
    >
      <!-- 查询条件表单 Start -->
      <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
      <el-form
        ref="filterParams"
        class="c-form c-condition__form"
        :model="filterParams"
        :inline="true"
        label-position="right"
        label-width="90px"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="系统名称"
              prop="xtsbMc"
            >
              <select-sb
                v-model="filterParams.xtsbMc"
                clearable
                type="jc"
                show-all
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col o-form-btns"
            :span="12"
          >
            <k-button
              btn-text="查询"
              :auth-type="false"
              type="primary"
              icon="kestrel-icon ki-search"
              @click="refreshSearch()"
            />

            <k-button
              btn-text="重置"
              :auth-type="false"
              icon="kestrel-icon ki-repeat"
              @click="resetForm()"
            />
            <k-button
              btn-text="删除"
              :auth-type="true"
              icon="kestrel-icon ki-trash-o"
              type="danger"
              :disabled="multipleSelectedRow.length<1"
              @click="handleDel()"
            />
          </el-col>
        </el-row>
      </el-form>
      <k-button
        btn-text="消防设备其他说明"
        :auth-type="false"
        type="text"
        class="o-xfsb-desc"
        icon="kestrel-icon ki-file-text"
        @click="handleDialog('qtsm')"
      />
      <!-- 查询条件表单 End -->
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div
      class="l-page__body l-page--search__body"
    >
      <!-- table的ref的命名根据业务名称修改 -->
      <k-table
        ref="kTable"
        height="100%"
        :table-column="tableColumn"
        :data="page.rows"
        :pagination="page"
        :multiple="true"
        @current-change="search"
        @size-change="handleSizeChange"
        @selection-change="handleSelectionChange"
      >
        <template
          #xfsbmc="scope"
        >
          <el-link
            type="primary"
            @click="handleDialog('view', {id: scope.row.xfsbdjId})"
          >
            {{ scope.row.xfsbmc }}
          </el-link>
        </template>
        <template
          #hgz="scope"
        >
          {{ scope.row.hgz === 'Y'?'合格':scope.row.hgz === 'N'?'不合格':'' }}
        </template>

        <el-table-column
          v-if="showType === 'edit'"
          prop="enabled"
          label="操作"
          width="100"
          align="center"
          fixed="right"
        >
          <template
            slot-scope="scope"
          >
            <k-button
              btn-text="编辑"
              :auth-type="true"
              type="primary"
              plain
              @click="handleEdit(scope.row.xfsbdjId)"
            />
            <!-- <k-button
          btn-text="导出"
:auth-type="false"

              type="danger"
              @click="handleDel(scope.row, scope.$index)"
            >
              删除
            </k-button> -->
          </template>
        </el-table-column>
      </k-table>

      <k-button
        btn-text="消防设备导入模板"
        :auth-type="true"
        type="text"
        @click="handleDownload()"
      />
    </div>
    <!-- 页面主内容：查询列表 End -->

    <!-- 其他说明 -->
    <jcsb-qtsm-dialog
      v-if="showDialogName==='qtsm'"
      :xm-id="xmId"
      :show-type="type"
      @callback="refreshSearch()"
      @closeDialog="handleDialog"
    />

    <!-- 设备录入 -->
    <jcsb-add-dialog
      v-if="showDialogName==='add'"
      :xm-id="xmId"
      @callback="refreshSearch()"
      @closeDialog="handleDialog"
    />

    <!-- 设备修改 -->
    <jcsb-edit-dialog
      v-if="showDialogName==='edit'"
      :xm-id="xmId"
      :xfsbdj-id="xfsbdjId"
      @callback="refreshSearch()"
      @closeDialog="handleDialog"
    />

    <!-- 设备查看 -->
    <jcsb-view-dialog
      v-if="showDialogName==='view'"
      :dl-params="dialogParams"
      :xm-id="xmId"
      @callback="refreshSearch()"
      @closeDialog="handleDialog"
    />
  </div>
</template>

<script>
import { xfsbService } from '../xfsb/xfsb.service';
import JcsbQtsmDialog from '../xfsb/qtsmDialog.vue';
import JcsbAddDialog from '../xfsb/addDialog.vue';
import JcsbViewDialog from '../xfsb/viewDialog.vue';
import JcsbEditDialog from '../xfsb/editDialog.vue';

export default {
  name: 'XfsbIndex',
  components: {
    JcsbQtsmDialog,
    JcsbAddDialog,
    JcsbViewDialog,
    JcsbEditDialog
  },
  props: {
    type: { type: String, default: null }
  },
  data () {
    return {
      loading: false, // 页面是否loading状态
      xmId: '', // 项目ID
      xfsbdjId: '', // 消防设备登记id
      dialogParams: {}, // 弹窗参数
      importUrl: '',
      upLoadText: null,
      showType: null, // 显示类型，查看：view、编辑：edit

      multipleSelectedRow: [], // 表格选中行（多选）
      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        xmId: null,
        xtsbMc: null, // 系统设备名称
        xtmc: null, // 系统名称
        sbmc: null // 设备名称
      },
      /* 查询条件 end */

      /** 弹窗参数 START */
      showDialogName: '',
      /** 弹窗参数 END */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'xfxtmc', label: '系统名称', align: 'left', minWidth: '150', type: 'text' },
        { key: 'xfsbmc', slotName: 'xfsbmc', label: '设备名称', align: 'left', minWidth: '180', type: 'text' },
        { key: 'xfsbsl', label: '数量', align: 'center', width: '60', type: 'text' },
        { key: 'xfsbxh', label: '产品型号/生产厂家', align: 'left', minWidth: '180', type: 'text' },
        { key: 'xfsbzmwj', label: '符合法定市场准入规则的证明文件', align: 'left', minWidth: '130', type: 'text' },
        { key: 'hgz', slotName: 'hgz', label: '合格证', align: 'center', width: '60', type: 'text' },
        { key: 'ccrq', label: '出厂日期', align: 'center', width: '90', type: 'date' },
        { key: 'bz', label: '备注', align: 'left', width: '200', type: 'text' }
      ]
      /* 表格列配置End */

    };
  },
  methods: {
    /**
     * @description: 表格选中行事件（多选）
     * @param {Object} val
     * @return {*}
     */
    handleSelectionChange (val) {
      console.log(val);
      this.multipleSelectedRow = val;
    },
    /**
     * 编辑修改
     */
    handleEdit (_sbid) {
      this.xfsbdjId = _sbid;
      this.handleDialog('edit');
    },
    /**
     * @description: 文件导入成功后操作
     * @return {*}
     */
    handleImportSuccess () {
      const _this = this;
      _this.$alert('导入成功！', '提示', {
        confirmButtonText: '确定',
        type: 'success',
        callback: action => {
          _this.refreshSearch();
        }
      });
    },
    /**
     * @description: 触发上传按钮
     * @return {*}
     */
    submitUpload () {
      this.upLoadText = {
        creator: window.sessionStorage.getItem('accountName'),
        fileName: this.fileName,
        requirement: this.selectedRequirement
      };
      console.log(this.$refs.fduploadsbxx);
      this.$refs.fduploadsbxx.handleClick();
      this.loading = false;
    },
    /**
     * @description: 文件上传前处理
     * @return {*}
     */
    handlePreview () {
      const _this = this;
      const h = this.$createElement;
      this.$confirm('提示', {
        title: '提示',
        message: h('div', [h('p', '1、请使用模板导入设备信息，表中数据均为必填信息。'), h('p', '2、为保证成功，请根据表中数据格式及字段顺序依次填写。')]),
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          _this.loading = true;
          _this.submitUpload();
        }).catch(() => {
        });
      _this.loading = false;
    },
    /**
     * @description: 通用显示模态框dialog组件
     * @param {String} _name 显示的模态框dialog名称
     * @param {Object} _params 模态框dialog传入参数
     * @return {*}
     */
    handleDialog (_name, _parmas) {
      console.log(_name, _parmas);
      this.showDialogName = _name;
      this.dialogParams = _parmas;
    },
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      if (this.filterParams.xtsbMc && this.filterParams.xtsbMc.includes('/')) {
        [this.trueFilterParams.xtDm, this.trueFilterParams.sbDm] = this.filterParams.xtsbMc.split('/');
      }
      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */
      this.loading = true;
      xfsbService.queryXfsb(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields(); ;
    },
    /**
     * @description: 删除
     * @return {*}
     */
    handleDel () {
      const _this = this;
      const xfsbNameList = this.multipleSelectedRow.map(item => {
        return '【' + item.xfsbmc + '】';
      });
      _this.$confirm(`是否确认删除设备信息${xfsbNameList}？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        const ids = this.multipleSelectedRow.map(item => {
          return item.xfsbdjId;
        });
        xfsbService.deleteXfsbList({ ids: ids })
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.search();
            _this.multipleSelectedRow = [];
          })
          .catch(err => {
            console.error('删除失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },

    /**
     * @description: 点击下载
     * @param {*}
     * @return {*}
     */
    handleDownload () {
      this.loading = true;
      xfsbService.exportSbmbFile()
        .then((rsp) => {
          const fileStream = rsp.data;
          const fileName = decodeURIComponent(escape(rsp.headers['content-disposition'].split('=')[1]));
          this.$HMUtil.downloadStreamFile(fileStream, fileName);
        })
        .catch(err => {
          console.error('设备模板下载出错', err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created () {
    this.xmId = this.$route.params.xmId;
    this.filterParams.xmId = this.$route.params.xmId;
    this.importUrl = this.$config.ctx.iffApi + `/xfjc/jcsb/${this.xmId}/import`;
    this.showType = this.type;
    this.refreshSearch();
    console.log(this.type, 'type');
  }
};
</script>

<style scoped>
  .o-form-btns{
    display: flex;
    align-items: center;
    padding-left: 10px;
  }

  .o-xfsb-desc{
    position: absolute;
    top: 20px;
    right: 16px;
  }
</style>
